import { Sparkles } from "lucide-react";

// Branded placeholder shown until the ADMIN uploads real ELVOSH product photos.
export default function ProductPlaceholder({ className = "", label = "Product photo coming soon" }) {
    return (
        <div
            className={`flex flex-col items-center justify-center bg-cream-soft text-muted-foreground ${className}`}
            data-testid="product-placeholder"
        >
            <div className="font-serif text-3xl tracking-[0.3em] text-ink/80">ELVOSH</div>
            <div className="mt-2 flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em]">
                <Sparkles className="h-3 w-3 text-gold" strokeWidth={1.5} />
                {label}
            </div>
        </div>
    );
}
